export const de = {
    actions: {
        success: 'Erfolg!',
        save: "Speichern",
        cancel: "Abbrechen",
        dispatch: "Dispatch",
        edit: "Bearbeiten"
    },
    dashboard: {
        title: "Dashboard",
        turnover: "Umsatz",
        returns: "Retouren",
        orders: "Bestellungen"
    },
    articles: {
        title: "Artikel",
        sku: "SKU",
        ean: "EAN",
        description: "Bezeichnung",
        stock: "Bestand",
        price: "Preis (Brutto)",
        discountPrice: "Rabattpreis (Brutto)",
        stockProtected: "Geschützer Bestand",
        stockOverwrite: "Gesetzter Bestand",
        toTb: "TB",
        toSw: "SW",
        toGx: "GX",
        toMa: "MA",
        search: "Suche nach SKU, EAN oder Bezeichnung ...",
        sw: "Shopware Artikel",
        gx: "Galaxus Artikel",
        tb: "Tradebyte Artikel",
        ma: "Manor Artikel",
        protected: "Geschützter Bestand",
        editTitle: "Bestandes Konfiguration",
        editDescription: "Um einen Bestand zu überschreiben, die Checkbox aktivieren und einen manuellen Bestand eintragen.",
        updated: "Artikel wurde gespeichert"
    },
    inventory: {
        title: "Lagerbewegungen",
        search: "Suche nach SKU, EAN oder Bezeichnung ...",
        createdAt: "Datum",
        sku: "SKU",
        diff: "Differenz",
        currentStock: "Neuer Bestand",
        name: "Bezeichnung",
        type: "Art",
        inbound: "Eingang",
        outbound: "Ausgang"
    },
    integrations: {
        title: "Kanäle",
        search: "Suche nach Name, Integration oder Code ...",
        id: "Id",
        name: "Bezeichnung",
        code: "Code",
        integration: "Techn. Integration",
        active: "Aktiv",
        handles_orders: "Verarbeitet Bestellungen",
        manages_payments: "Verarbeitet Zahlungen",
        inactive: "Inaktiv",
        color: "Farbe",
        locale: "Sprach-Code",
        currency: "Währung",
        user: "Benutzername (Api)",
        password: "Passwort (Api)",
        endpoint: "Endpoint (Api)",
        updated: "Integration wurde gespeichert",
        editTitle: "Organisation konfigurieren",
        editDescription: "With great power, comes great responsibility. Eine falsche Einstellung kann fatale Folgen haben =)",
    },
    jobs: {
        title: "Job Management",
        dispatched: "Job dispatched"
    },
    outbox: {
        title: "Kanalmeldungen",
        disabledHint: "Der Outbox-Modus ist deaktiviert. Meldungen gehen weiterhin direkt auf die Queue und werden hier nicht erfasst.",
        search: "Auftragsnummer suchen",
        createdAt: "Erfasst",
        orderNumber: "Auftrag",
        channel: "Verkaufskanal",
        positions: "Positionen",
        attempts: "Versuche",
        lastError: "Letzter Fehler",
        statusLabel: "Status",
        typeLabel: "Meldung",
        retry: "Erneut senden",
        retryFailed: "Alle {amount} fehlgeschlagenen erneut senden",
        retried: "Meldung wurde erneut eingereiht",
        status: {
            pending: "Offen",
            dispatched: "In Zustellung",
            completed: "Zugestellt",
            failed: "Fehlgeschlagen"
        },
        type: {
            shipped: "Versendet",
            cancelled: "Storniert",
            returned: "Retourniert"
        }
    },
    orders: {
        title: "Auftrag",
        orderDate: "Auftragsdatum",
        orderReceived: "Auftragseingang",
        number: "Nummer",
        channel: "Verkaufskanal",
        channelNo: "Kanal Nr.",
        total: "Betrag",
        customer: "Kunde",
        paymentState: "Zahlungstatus",
        fulfillmentState: "Lieferstatus",
        orderNumber: "Auftragsnummer",
        extOrderNumber: "Ext. Auftragsnumer",
        extId: "Ext. Id",
        fulfilling: "Versand freigegeben",
        totalNet: "Total Netto",
        totalTax: "Total MWST",
        totalGross: "Total Brutto",
        shipping: "Lieferadresse",
        billing: "Rechnungsadresse",
        contact: "Kontakt",
        documents: "Dokumente",
        dispatch: "Versand",
        releaseEvents: "Dispatch Events",
        pos: "Pos",
        article: "Artikel",
        description: "Bezeichnung",
        payment: "Zahlung",
        shipment: "Lieferung",
        code: "Code",
        refresh: "Neuer Status angefragt",
        refund: "Zurückerstatten",
        refunded: "Positionen wurden rückerstattet",
        listTitle: "Aufträge",
        updated: "Bestellung wurde aktualisiert",
        address: {
            updated: "Adresse aktualisiert",
            company: "Firma",
            firstname: "Vorname",
            lastname: "Nachname",
            street: "Strasse",
            street_ext: "Erweiterte Adresszeile",
            zip: "PLZ",
            city: "Stadt",
            country: "Land",
            editAddress: "Adresse bearbeiten",
            companyNote: "Ist eine Firma gesetzt, wird diese beim Adressetikett zuoberst angezeigt.",
            pickupNode: "Handelt es sich um eine PickPost/MyPost-Bestellung, muss die User-Id in die erweiterte Adresszeile eingegeben werden. Zb. MyPost24 / PT336792 oder PickPost PT234212",
        }
    },
    monitoring: {
        title: "Monitoring",
        total: "Total",
        open: "Offen",
        inProcess: "In Bearbeitung",
        shipped: "Versendet",
        critical: "Kritisch",
        cancellationRequested: "Stornierungsanfrage offen",
        partialDelivery: "Teilw. Ausgeliefert",
        returned: "Kompl. Retourniert",
        partialReturned: "Teilw. Retourniert",
        viewMore: "Details",
        gotoList: "Zur Liste",
        criticalWarning: (ctx) => `Es gibt ${ctx.named('amount')} Aufträge die seit mehr als 3 Tage nicht bearbeitet wurden.`,
        cancellationWarning: (ctx) => `Es gibt ${ctx.named('amount')} Aufträge die vom Logistik-Partner storniert wurden.`,
    },
    ranges:{
        placeholder: "Zeitraum",
        today: "Heute",
        last7: "Letzte 7 Tage",
        thisMonth: "Diesen Monat",
        lastMonth: "Letzten Monat",
        thisYear: "Dieses Jahr"
    }
}
